import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const ArchiveIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.14286 13.1429H14.8571M4 4H20V8.57143H4V4ZM5.14286 8.57143V18.8571C5.14286 19.4883 5.65453 20 6.28571 20H17.7143C18.3455 20 18.8571 19.4883 18.8571 18.8571V8.57143H5.14286Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Box>
  );
};
